<template>
  <div>
    <div class="app-top">
      <!-- <swiper-list :dataList="swiperList" :height="350" :interval="4000"></swiper-list> -->
    </div>
    <div class="center">
      <div class="container">
        <div style="max-width: 400px; margin:10px auto;padding: 40px 0 20px 0;">
          <el-form ref="form" :model="form" :rules="rules" :label-position=" isPc ? 'right' :'right'" label-width="100px" size="normal">
            <el-form-item>
              <!-- 标题 -->
              <div style="margin-bottom: 10px;text-align: center;">
                <h2 style="font-size: 22px;font-weight: bold;color:#333">重置密码</h2>
                <h3
                  style="margin-top: 10px;font-size: 16px;font-weight: normal;color:#666"
                  v-if="$route.query.softLicenseCode"
                >{{form.productName}}</h3>
              </div>
            </el-form-item>
            <div v-if="isSuccess==false">
              <el-form-item prop="productCode" label="选择产品" v-if="!$route.query.softLicenseCode">
                <product-select
                  :text="form.productName"
                  :onlyHasNetwork="true"
                  @change="form.productCode = $event.licenseCode,form.productName = $event.name"
                />
              </el-form-item>
              <el-form-item prop="phone" label="手机号码">
                <el-input v-model="form.phone" placeholder="登录账号" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item prop="code" label="验证码">
                <el-input v-model="form.code" style="width:50%" placeholder="短信验证码" type="text" />
                <el-button
                  style="width: calc(50% - 10px);margin-left: 10px;"
                  type
                  :disabled="!canSend"
                  :class="['code-side',!canSend ? 'code-side-default' : '']"
                  @click="getImage"
                >{{ codeName }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSubmit" style="width: 100%;">确认重置</el-button>
                <div style="text-align: center;margin-top: 10px;">
                  <contact-service text="联系客服"></contact-service>
                </div>
              </el-form-item>
            </div>
            <el-form-item v-if="isSuccess">
              <div>
                <div>
                  <div style="color:green;">重置成功！</div>
                  <div style="line-height: 26px;">
                    账号：{{ form.phone }}
                    <br />用户：admin
                    <br />密码：空
                    <div style="color:#999"></div>
                    <div style="color:#999">请返回客户端登录。</div>
                    <div style="color:#999">并及时修改为其他用户名和密码。</div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <comm-desc />
    <verify-code-image-dialog ref="imgDialog" @confirm="sendCode" />
  </div>
</template>
  
<script>
import API from '@/api/_common.js'
import commDesc from '@/components/commDesc'
import productSelect from '@/components/productSelect.vue'
import VerifyCodeImageDialog from '@/components/VerifyCodeImageDialog'
export default {
  name: 'TenantResetUserPassword',
  components: {
    commDesc,
    productSelect,
    VerifyCodeImageDialog
  },
  data() {
    return {
      dataList: [],
      form: {
        productCode: '',
        productName: '',
        phone: '',
        code: '',
        name: ''
      },
      codeName: '获取验证码',
      canSend: true,
      isSuccess: false,
      rules: {
        productCode: [{ required: true, message: '请选择产品', trigger: 'change' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'change' }],
        code: [{ required: false, message: '请输入验证码', trigger: 'change' }]
      }
    }
  },
  watch: {},
  computed: {
    isPc() {
      return document.body.clientWidth > 800
    }
  },
  mounted() {
    if (this.$route.query) {
      this.form.productCode = this.$route.query.softLicenseCode || ''
      this.form.productName = this.$route.query.softName || ''
    }
  },
  created() {},
  methods: {
    //获取图片验证码
    getImage() {
      this.$refs.form.clearValidate(['code'])
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.canSend) {
            this.$refs.imgDialog.handleOpen()
          }
        }
      })
    },
    //发送短信
    sendCode(data) {
      console.log('sendCode', data)
      this.$refs.form.clearValidate(['code'])
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.canSend) {
            API.verifyCodeSend({
              product: this.form.productCode,
              target: this.form.phone,
              type: 'ResetPassword',
              imageKey: data.key,
              imageCode: data.code
            })
              .then(res => {
                console.log('已发送', res)
                //已发送,开始倒计时
                this.countDown(60, this)
                this.$refs.imgDialog.close()
              })
              .catch(err => {
                console.error(err)
                this.$refs.imgDialog.refreshImage()
              })
          }
        }
      })
    },
    //显示倒计时
    countDown(num, that) {
      var remainTime = num
      var cacheTime = new Date().getTime()
      var timer = setInterval(function () {
        var currTime = new Date().getTime()
        var vanishTime = Math.ceil(currTime - cacheTime) // 获得消失的时间
        var newRemainTime = parseInt(remainTime - vanishTime / 1000)
        if (newRemainTime >= 1) {
          that.codeName = `重新发送(${newRemainTime}s)`
          that.canSend = false
        } else {
          that.codeName = '获取验证码'
          that.canSend = true
          clearInterval(timer)
        }
      }, 1000)
    },
    handleSubmit() {
      this.$refs.form.validateField(['code'])
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          API.resetUserPassword({
            product: this.form.productCode,
            account: that.form.phone,
            code: that.form.code
          }).then(res => {
            this.isSuccess = true
            alert(res.message || '操作成功')
          })
        }
      })
    }
  }
}
</script>
  <style lang="scss" scoped>
@media screen and (max-width: 576px) {
}

.app-top {
  margin-top: 58px;
}
</style>